import React from 'react';
import moment from 'moment';
import { BannerReact } from 'common/components/banner';
import { BannerTheme, BannerType } from 'common/components/banner/types';
import { useTranslation } from 'common/i18n/hooks';
import { useTestingModelModifiers } from 'iron/apps/experiments/src/components/hooks/testing-model-modifiers';
import { SelectTheme } from 'common/components/select/constants';
import { ProgressIcon } from 'common/components/svg-icon/progress';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { COMPLETION_DATE_STATUS, computeCompletionDate, computeStatusPercent } from 'iron/apps/experiments/src/components/utils';
import { SelectReact } from 'common/components/select';
import { formatSignificantResults } from './helper';
import { ExposuresMakeDecision } from './_exposures-make-decision';
export function ExperimentPageBannerRunning() {
  var _experiment$results_c, _experiment$results_c2;
  const i18n = useTranslation();
  const experiment = useExperimentsStore(state => state.experiment)!;
  const {
    noPeeking
  } = useTestingModelModifiers();
  const completionDate = computeCompletionDate(experiment);
  const completionPercent = computeStatusPercent(experiment);
  let daysRemaining = "";
  if (completionDate.date) {
    const days = moment(completionDate.date).diff(moment(), "days");
    if (completionDate.status === COMPLETION_DATE_STATUS.ACTUAL) {
      daysRemaining = i18n.t("experiments.banner.running.days-remaining", {
        days
      });
    } else if (completionDate.status === COMPLETION_DATE_STATUS.ESTIMATED) {
      daysRemaining = i18n.t("experiments.banner.running.days-remaining-estimated", {
        days
      });
    }
  } else if (completionDate.status === COMPLETION_DATE_STATUS.PENDING_DATA) {
    daysRemaining = i18n.t("experiments.banner.running.pending-days-remaining");
  }
  const {
    hasSignificantResults,
    significantResults
  } = noPeeking ? {
    hasSignificantResults: false,
    significantResults: ""
  } : formatSignificantResults(i18n, (_experiment$results_c = (_experiment$results_c2 = experiment.results_cache) === null || _experiment$results_c2 === void 0 ? void 0 : _experiment$results_c2.summary) !== null && _experiment$results_c !== void 0 ? _experiment$results_c : {});
  const headerText = noPeeking ? i18n.t("experiments.banner.running.title-no-peeking") : hasSignificantResults ? i18n.t("experiments.banner.running.title-early-significance") : i18n.t("experiments.banner.running.title");
  let bodyText = noPeeking ? i18n.t("experiments.banner.running.body-no-peeking") : "";
  bodyText = "".concat(daysRemaining, " ").concat(significantResults, " ").concat(bodyText);
  const makeDecisionProps: React.ComponentProps<typeof SelectReact> = noPeeking ? {
    icon: {
      leftIcon: "ellipsis"
    },
    iconOnly: true
  } : {
    alwaysShowCaret: true,
    label: i18n.t("experiments.banner.common.exposures-make-decision.label")
  };
  return <>
      <BannerReact headerText={headerText} bodyText={bodyText} theme={BannerTheme.Base} type={BannerType.Embedded} icon='running' data-sentry-element="BannerReact" data-sentry-source-file="_running.tsx">
        <div slot={"icon"}>
          <ProgressIcon percent={completionPercent} data-sentry-element="ProgressIcon" data-sentry-source-file="_running.tsx" />
        </div>
        <div slot={"cta"}>
          <ExposuresMakeDecision {...makeDecisionProps} theme={SelectTheme.Tertiary} data-sentry-element="ExposuresMakeDecision" data-sentry-source-file="_running.tsx" />
        </div>
      </BannerReact>
    </>;
}